import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./dalia.css";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import ProductCard from "../../components/productCard/ProductCard";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";

const Dalia = () => {
  return (
    <>
      <Navb />
      <div className="daliamaintop">
        <div className="daliatoptext">
          "Nandi Dalia: Wholesome <br /> Goodness in Every Grain, Every <br />
          Bite."
        </div>
        <img
          src={Img2}
          alt="Img2"
          style={{ display: "block", padding: "8px 50px 0px" }}
        />
      </div>

      <div className="whiteComponentsingleEcavo daliabg" id="NANDI_Premium_Dalia">
        <SingleRecipiePage
          currrentImg={Img3}
          heading="NANDI Premium Dalia"
          text="Embark on a journey of wholesome indulgence with Nandi's Premium Dalia, where every spoonful transports you to a world of nourishment and comfort. Made from the finest grains and lovingly crafted to perfection, Nandi's Premium Dalia is a symphony of texture and taste. Whether enjoyed as a hearty breakfast or a satisfying meal, let the warmth of Nandi's Dalia embrace your senses and nourish your soul."
          link1="/recipes/daliakhichadi"
          link1Text="View Recipes"
          link2="https://ecavo.shop/products/daliya"
          linkClass="blackButton"
          //   sideImg={Sideimg1}
          headingcss="blackHeading"
          pcss="blackP"
        />
      </div>
      <div className="productCards">
        <ProductCard
          Heading="Hygienic Production"
          Text="Nandi's Premium Dalia is produced under stringent hygienic conditions, ensuring purity and safety in every bite. With quality control measures in place, you can trust that each serving of Nandi's Premium Dalia meets the highest standards of cleanliness and food safety."
        />
        <ProductCard
          Heading="Metabolism Boost"
          Text="Packed with nutrients and fiber, Nandi's Premium Dalia helps in boosting metabolism. Its high fiber content aids digestion and keeps your digestive system healthy, promoting better absorption of nutrients and overall metabolic efficiency."
        />
        <ProductCard
          Heading="Easy Digestibility"
          Text="Thanks to its finely ground texture and high fiber content, Nandi's Premium Dalia is easily digestible, making it a gentle option for those with sensitive stomachs or digestive issues. Enjoy a comforting meal without worrying about discomfort, as Nandi's Dalia supports smooth digestion and gastrointestinal health"
        />
      </div>
      <Footer />
    </>
  );
};

export default Dalia;
